document.addEventListener('click',async event=>{
  const button=event.target.closest('[data-ncu-undo]');
  if(!button||button.disabled)return;
  const drawer=button.closest('cart-drawer');
  if(!drawer||drawer.hasAttribute('data-protection-busy'))return;
  button.disabled=true;
  const checkout=drawer.querySelector('[name="checkout"]');
  if(checkout)checkout.disabled=true;
  try{
    const root=window.Shopify.routes.root;
    const before=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
    if(!before.ok)throw new Error('Cart unavailable');
    const cart=await before.json();
    const updates={};
    cart.items.filter(item=>String(item.variant_id)===button.dataset.ncuUndo&&item.properties?._nolya_cart_upsell==='single-product').forEach(item=>{updates[item.key]=0});
    if(!Object.keys(updates).length){window.location.reload();return;}
    const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates,sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})});
    const result=await response.json();
    if(!response.ok||result.status||result.errors)throw new Error('Cart update failed');
    if(!result.sections?.['cart-drawer']){window.location.reload();return;}
    drawer.renderContents(result);
    if(typeof publish==='function')publish(PUB_SUB_EVENTS.cartUpdate,{source:'nolya-cart-upsell',cartData:result});
  }catch(error){
    button.closest('.ncu__added').querySelector('[role="status"]').textContent=button.dataset.error;
    button.disabled=false;
  }finally{
    if(checkout?.isConnected)checkout.disabled=false;
  }
});
